import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Row, Col, FormGroup, Input, Label, Button, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import NumberFormat from "react-number-format";
import { Validacao } from "../../comum/components/Validacao";
import PropTypes from "prop-types";
import Select from "react-select";
import qs from "query-string";
import _ from "lodash";
import HistoricoContratacaoFiltroStore from "../stores/HistoricoContratacaoFiltroStore";

@inject("store")
@observer
export class HistoricoContratacaoFiltro extends Component {
    static propTypes = {
        history: PropTypes.object,
        location: PropTypes.object,
        onSubmit: PropTypes.func.isRequired,
        inicialDataValue: PropTypes.object,
        simular: PropTypes.bool.isRequired
    };

    constructor(props) {
        super(props);
        this.controller = new HistoricoContratacaoFiltroStore(this.props.inicialDataValue);
        this.validacaoStore = this.props.store.validacaoStore;
    }

    componentDidMount() { // OK
        const params = qs.parse(this.props.location.search);

        this.controller.carregarListas(params, this.props.fields);

        if (_.isEmpty(params)) {
            //this.controller.setAnoCorrente(this.props.fields);
        } else {
            this.props.onSubmit(this.controller.getFiltro());
        }
    }

    onSubmit = (event) => { //OK
        event.preventDefault();
        event.stopPropagation();

        if (!this.canSubmit()) {
            return;
        }
/*
        if (this.props.history && this.props.location) {
            this.props.history.push({
                pathname: this.props.location.pathname,
                search: qs.stringify(_.pickBy(this.controller.filtro, _.identity))
            });
        }
*/
        this.props.onSubmit(this.controller.getFiltro());
    }

    onClear = () => { //OK
        this.controller.limparFiltro(this.props.fields);
        if (this.props.controller) {
            this.props.controller.dadosMot = [];
            this.props.controller.dadosContrato = [];
            this.props.controller.dadosValidacao = null;
            this.props.controller.simulaQuarentena = false;
            this.props.controller.erro = null;
            this.props.store.formStore.setSubmitted(false);
            this.props.store.formStore.setSubmitMensagemErro("");
        }
        this.forceUpdate();
    }

    canSubmit = () => { //OK
        this.props.store.formStore.setSubmitted(true);
        this.props.store.formStore.setSubmitMensagemErro("");

        return this.props.store.validacaoStore.isValidForm;
    }

    render() {
        return (
            <div className="filter-container">
                <form onSubmit={(event) => this.onSubmit(event)} className="filter-box">
                    {!this.props.simular &&
                        <Col>
                            <Row>
                                <Col xs={12} md={6} lg={2}>
                                    <FormGroup>
                                        <Label for="cpf">CPF</Label>
                                        <NumberFormat id="cpf"
                                            className="form-control"
                                            format="###.###.###-##"
                                            value={this.controller.cpfSelecionado}
                                            onChange={(event, values) => this.controller.setCPF(values.value)} />
                                        <Validacao id={"cpf"} valor={this.controller.cpfSelecionado} tipo={["isCPF"]} />
                                        <Validacao id="cpfObrigatorio" valor={this.controller.cpfSelecionado}
                                            tipo={["isRequired"]} />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} md={6} lg={6}>
                                    <FormGroup>
                                        <Label for="mots">Nome MOT</Label>
                                        <Select id="mots"
                                                placeholder="Todos"
                                                searchingText="Pesquisando..."
                                                noResultsText="Nenhum resultado encontrado"
                                                searchPromptText="Informe nome para pesquisar"
                                                isLoading={this.controller.buscandoMOT} // Passa buscandoMOT para o Select
                                                multi={false}
                                                value={this.controller.motSelecionado}
                                                onChange={(value, options) => this.controller.setMOTs(value, options)}
                                                asyncOptions={(input, callback) => this.controller.filtrarMotsDebounce(input, callback)} 
                                                />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    {this.props.onSubmit &&
                                        <Button color="primary" type="submit">Filtrar</Button>
                                    }
                                    {" "}
                                    {" "}
                                    <Button onClick={() => this.onClear()}>Limpar</Button>
                                </Col>
                            </Row>
                        </Col>
                    }
                    <div className="separador"></div>
                    {this.props.simular &&
                        <Col>
                            <Row>
                                <Col xs={12} md={6} lg={5}>
                                    <FormGroup>
                                        <Label for="empresas">Unidades de negócio (BUs)</Label>
                                        <Select id="empresas"
                                            value={this.controller.filtro.empresaGloboId}
                                            onChange={(value) => this.controller.setEmpresa(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Selecione a Empresa para simular a quarentena"
                                            multi={false}
                                            options={[...this.controller.empresas]} />
                                        {<Validacao id="empresasObrigatorias" valor={this.controller.empresasValidacao}
                                            tipo={["isRequired"]} />
                                        }
                                    </FormGroup>
                                </Col>
                                <Col xs={12} md={6} lg={4}>
                                    <FormGroup>
                                        <Label for="cargos">Cargo</Label>
                                        <Select id="cargos"
                                            value={this.controller.filtro.cargoId}
                                            onChange={(value) => this.controller.setCargo(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Selecione um cargo para simular a quarentena"
                                            multi={false}
                                            options={[...this.controller.cargos]} />
                                        {<Validacao id="cargosObrigatorios" valor={this.controller.cargosValidacao}
                                            tipo={["isRequired"]} />
                                        }
                                    </FormGroup>
                                </Col>
                                <Col xs={12} md={6} lg={2}>
                                    <FormGroup>
                                        <Label for="propostaSalario">Salário Proposto</Label>
                                        <NumberFormat id="propostaSalario"
                                            allowNegative={false}
                                            className="form-control"
                                            thousandSeparator="."
                                            decimalPrecision={2}
                                            decimalSeparator=","
                                            prefix={'R$ '}
                                            value={this.controller.filtro.propostaSalario}
                                            onChange={(event, values) => this.controller.setPropostaSalario(values.floatValue)}
                                        />
                                        {<Validacao id="propostaSalario" valor={this.controller.propostaSalarioValidacao}
                                            tipo={["isRequired"]} />}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    {this.props.onSubmit &&
                                        <Button color="primary" type="submit">Simular Quarentena</Button>
                                    }
                                    {" "}
                                    {" "}
                                    <Button onClick={() => this.onClear()}>Consultar outro CPF</Button>
                                </Col>
                            </Row>
                        </Col>
                    }
                </form>
            </div>
        );
    }
}
